<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img26.jpg"/></p>
<p class="chap"><a id="ch12"></a>BARON DE LA WARE, 1610</p>
<p class="noindent"><span class="big">I</span>n the English settlement of North America, settlers and investors were hopeful of rich harvests, gold and silver, and friendly natives eager for trade. The largest investor in Virginia was Thomas West, the twelfth Baron De La Ware, a distant cousin of Queen Elizabeth I, and a member of the Queen’s Council.</p>
<p class="indent">In 1609, word came of the worsening situation in Virginia. West was appointed governor and set off for the Chesapeake to rescue his investment. He arrived just as the colonists, who numbered sixty, down from a high of five hundred, were in the process of abandoning the colony. The baron reinvigorated colonial morale and built forts on the river for protection. After some time, West’s health deteriorated, and he went back to England to recover. He died in mid-Atlantic on his return to Jamestown. Later, the colony of Delaware was named in honor of the man who saved Virginia. <span class="color">(11-073)</span></p>
<p class="image"><img alt="image" src="images/img27.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter012.vue?72739dbd